const songUpdate = [
   {
      product: "Alpha 2",
      years: [
         {
            year: 2026,
            months: [
               {
                  month: "August",
                  link: "https://www.mediafire.com/file_premium/0w7gal8m7ftt4j2/Alpha_2_08-2026.zip/file",
               },
               {
                  month: "July",
                  link: "https://www.mediafire.com/file_premium/z8xuzstnvvo3lv7/Alpha_2_07-2026.zip/file",
               },
               {
                  month: "June",
                  link: "https://www.mediafire.com/file_premium/zv0r7ep2kvbsn7f/Alpha_2_06-2026.zip/file",
               },
               {
                  month: "May",
                  link: "https://www.mediafire.com/file_premium/pv4okryxv0mb33h/Alpha_2_05-2026.zip/file",
               },
               {
                  month: "April",
                  link: "https://www.mediafire.com/file_premium/bc8p99p4gk5z38l/Alpha_2_04-2026.zip/file",
               },
               {
                  month: "March",
                  link: "https://www.mediafire.com/file_premium/vydsftjle15bc2s/Alpha_2_03-2026.zip/file",
               },
               {
                  month: "February",
                  link: "https://www.mediafire.com/file_premium/ivq9fujmg3qdf84/Alpha_2_02-2026.zip/file",
               },
               {
                  month: "January",
                  link: "https://www.mediafire.com/file_premium/epastebxvke9imq/Alpha_2_01-2026.zip/file",
               },
            ],
         },
         {
            year: 2025,
            months: [
               {
                  month: "December",
                  link: "https://www.mediafire.com/file_premium/b78md3r88i5mn39/Alpha_2_12-2025.zip/file",
               },
               {
                  month: "November",
                  link: "https://www.mediafire.com/file_premium/jktakwnlgku2r67/Alpha_2_11-2025.zip/file",
               },
               {
                  month: "October",
                  link: "https://www.mediafire.com/file_premium/5qbuzy7giu7slum/Alpha_2_10-2025.zip/file",
               },
               {
                  month: "September",
                  link: "https://www.mediafire.com/file_premium/5zdbpj19ivsc35a/Alpha_2_09-2025.zip/file",
               },
               {
                  month: "August",
                  link: "https://www.mediafire.com/file_premium/wbmb2mw1oe6w4ok/Alpha_2_08-2025.zip/file",
               },
               {
                  month: "July",
                  link: "https://www.mediafire.com/file_premium/bmkkh7a1ybq05gv/Alpha_2_07-2025.zip/file",
               },
               {
                  month: "June",
                  link: "https://www.mediafire.com/file_premium/0rbmb3cyh4pfydb/Alpha_2_06-2025.zip/file",
               },
               {
                  month: "May",
                  link: "https://www.mediafire.com/file_premium/iggtiq9chv9jk3x/Alpha_2_05-2025.zip/file",
               },
               {
                  month: "April",
                  link: "https://www.mediafire.com/file_premium/u1tkprf5omnw1st/Alpha_2_04-2025.zip/file",
               },
               {
                  month: "March",
                  link: "https://www.mediafire.com/file_premium/gmmikom9cdd48u3/Alpha_2_03-2025.zip/file",
               },
               {
                  month: "February",
                  link: "https://www.mediafire.com/file_premium/qtdhshdk3ww3fmj/Alpha_2_02-2025.zip/file",
               },
               {
                  month: "January",
                  link: "https://www.mediafire.com/file_premium/hofsfevts5qbem3/Alpha_2_12-2024.zip/file",
               },
            ],
         },
         {
            year: 2024,
            months: [
               {
                  month: "December",
                  link: "https://www.mediafire.com/file_premium/jbyhofkriju8uqx/Alpha_2_12-2024.zip/file",
               },
               {
                  month: "November",
                  link: "https://www.mediafire.com/file_premium/wpxqecdfxad1uny/Alpha_2_11-2024.zip/file",
               },
               {
                  month: "October",
                  link: "https://www.mediafire.com/file_premium/xqyov4356gmbnoo/Alpha_2_10-2024.zip/file",
               },
               {
                  month: "September",
                  link: "https://www.mediafire.com/file_premium/ibjwsdgrwlodvrp/Alpha_2_09-2024.zip/file",
               },
               {
                  month: "August",
                  link: "https://www.mediafire.com/file_premium/qob873ws2q7mh1x/Alpha_2_08-2024.zip/file",
               },
               {
                  month: "July",
                  link: "https://www.mediafire.com/file_premium/gfbcft3cangg9bn/Alpha_2_07-2024.zip/file",
               },
               {
                  month: "June",
                  link: "https://www.mediafire.com/file_premium/u9xxhhbkkrja8ca/Alpha_2_06-2024.zip/file",
               },
               {
                  month: "May",
                  link: "https://www.mediafire.com/file_premium/xjvgrwzv07mwdmx/Alpha_2_05-2024.zip/file",
               },
               {
                  month: "April",
                  link: "https://www.mediafire.com/file_premium/1ymzntilo5xppxb/Alpha_2_04-2024.zip/file",
               },
               {
                  month: "March",
                  link: "https://www.mediafire.com/file_premium/bzimupzx6b4spfg/Alpha_2_03-2024.zip/file",
               },
               {
                  month: "February",
                  link: "https://www.mediafire.com/file_premium/s2yanyn9en07men/Alpha_2_02-2024.zip/file",
               },
               {
                  month: "January",
                  link: "https://www.mediafire.com/file_premium/p0jni7kxtvyd19v/Alpha_2_01-2024.zip/file",
               },
            ],
         },
         {
            year: 2023,
            months: [
               {
                  month: "December",
                  link: "https://www.mediafire.com/file_premium/gfjxo746pptlcr1/Alpha_2_12-2023.zip/file",
               },
               {
                  month: "November",
                  link: "https://www.mediafire.com/file_premium/hdsawny59abmtx9/Alpha_2_11-2023.zip/file",
               },
               {
                  month: "October",
                  link: "https://www.mediafire.com/file_premium/k91ycrakw6r0txu/Alpha_2_10-2023.zip/file",
               },
               {
                  month: "September",
                  link: "https://www.mediafire.com/file_premium/murrcbtor04z71l/Alpha_2_09-2023.zip/file",
               },
               {
                  month: "August",
                  link: "https://www.mediafire.com/file_premium/645buku8urztnen/Alpha_2_08-2023.zip/file",
               },
               {
                  month: "July",
                  link: "https://www.mediafire.com/file_premium/tislprisxsrwu80/Alpha_2_07-2023.zip/file",
               },
               {
                  month: "June",
                  link: "https://www.mediafire.com/file_premium/nof8eu7hpmx5i2u/Alpha_2_06-2023.zip/file",
               },
               {
                  month: "May",
                  link: "https://www.mediafire.com/file_premium/c98vzw8p6yuzu5r/Alpha_2_05-2023.zip/file",
               },
               {
                  month: "April",
                  link: "https://www.mediafire.com/file_premium/wj373end1zjlzrg/Alpha_2_04-2023.zip/file",
               },
            ],
         },
      ],
   },
   {
      product: "Alpha",
      years: [
         {
            year: 2026,
            months: [
               {
                  month: "September",
                  link: "https://www.mediafire.com/file_premium/7gkoo3df930hxt5/Alpha_09-2026.zip/file",
               },
               {
                  month: "August",
                  link: "https://www.mediafire.com/file_premium/18bvq213h89fjqg/Alpha_08-2026.zip/file",
               },
               {
                  month: "July",
                  link: "https://www.mediafire.com/file_premium/9ix8sr73hcoasj9/Alpha_07-2026.zip/file",
               },
               {
                  month: "June",
                  link: "https://www.mediafire.com/file_premium/958m9eja4j117yv/Alpha_06-2026.zip/file",
               },
               {
                  month: "May",
                  link: "https://www.mediafire.com/file_premium/92p179avraj0yo1/Alpha_05-2026.zip/file",
               },
               {
                  month: "April",
                  link: "https://www.mediafire.com/file_premium/9b3e912vz6xzfh3/Alpha_04-2026.zip/file",
               },
               {
                  month: "March",
                  link: "https://www.mediafire.com/file_premium/obd2hez3z44w3et/Alpha_03-2026.zip/file",
               },
               {
                  month: "February",
                  link: "https://www.mediafire.com/file_premium/860pmosj2nq5wwm/Alpha_02-2026.zip/file",
               },
               {
                  month: "January",
                  link: "https://www.mediafire.com/file_premium/ztd5vgrafexzlox/Alpha_01-2026.zip/file",
               },
            ],
         },
         {
            year: 2025,
            months: [
               {
                  month: "December",
                  link: "https://www.mediafire.com/file_premium/h0vdgqqb1kmhyux/Alpha_12-2025.zip/file",
               },
               {
                  month: "November",
                  link: "https://www.mediafire.com/file_premium/7v0bmkmwuj3ek4s/Alpha_11-2025.zip/file",
               },
               {
                  month: "October",
                  link: "https://www.mediafire.com/file_premium/5jyr30pa800cde6/Alpha_10-2025.zip/file",
               },
               {
                  month: "September",
                  link: "https://www.mediafire.com/file_premium/z5dl7tv7jxahc8s/Alpha_09-2025.zip/file",
               },
               {
                  month: "August",
                  link: "https://www.mediafire.com/file_premium/r4wuayku6i6o4rj/Alpha_08-2025.zip/file",
               },
               {
                  month: "July",
                  link: "https://www.mediafire.com/file_premium/r3x37l9yeyjg7e7/Alpha_07-2025.zip/file",
               },
               {
                  month: "June",
                  link: "https://www.mediafire.com/file_premium/n70hc1h7rwg8mwv/Alpha_06-2025.zip/file",
               },
               {
                  month: "May",
                  link: "https://www.mediafire.com/file_premium/ahtx4iiqd743k3b/Alpha_05-2025.zip/file",
               },
               {
                  month: "April",
                  link: "https://www.mediafire.com/file_premium/59jtjihnbmbjdl7/Alpha_04-2025.zip/file",
               },
               {
                  month: "March",
                  link: "https://www.mediafire.com/file_premium/lzyzl5dosnnwnji/Alpha_03-2025.zip/file",
               },
               {
                  month: "February",
                  link: "https://www.mediafire.com/file_premium/4e8ott4f9dvq255/Alpha_02-2025.zip/file",
               },
               {
                  month: "January",
                  link: "https://www.mediafire.com/file_premium/9797hpab2ej3z3j/Alpha_12-2024.zip/file",
               },
            ],
         },
         {
            year: 2024,
            months: [
               {
                  month: "December",
                  link: "https://www.mediafire.com/file_premium/ppq29xeyalxr751/Alpha_12-2024.zip/file",
               },
               {
                  month: "November",
                  link: "https://www.mediafire.com/file_premium/3iadd6e1ex027ia/Alpha_11-2024.zip/file",
               },
               {
                  month: "October",
                  link: "https://www.mediafire.com/file_premium/cs9t3wc7ay1hjy3/Alpha_10-2024.zip/file",
               },
               {
                  month: "September",
                  link: "https://www.mediafire.com/file_premium/65h1g9j4zp9a2js/Alpha_09-2024.zip/file",
               },
               {
                  month: "August",
                  link: "https://www.mediafire.com/file_premium/4wbml12cvgwynyg/Alpha_08-2024.zip/file",
               },
               {
                  month: "July",
                  link: "https://www.mediafire.com/file_premium/sljm434fxdodlth/Alpha_07-2024.zip/file",
               },
               {
                  month: "June",
                  link: "https://www.mediafire.com/file_premium/nj1d8uzsy48jq5x/Alpha_06-2024.zip/file",
               },
               {
                  month: "May",
                  link: "https://www.mediafire.com/file_premium/9ifaf9s7pb64sbj/Alpha_05-2024.zip/file",
               },
               {
                  month: "April",
                  link: "https://www.mediafire.com/file_premium/gkz7aw4tn9jm660/Alpha_04-2024.zip/file",
               },
               {
                  month: "March",
                  link: "https://www.mediafire.com/file_premium/bdgaekgl2hnd3af/Alpha_03-2024.zip/file",
               },
               {
                  month: "February",
                  link: "https://www.mediafire.com/file_premium/67y5o2vdt5djshm/Alpha_02-2024.zip/file",
               },
               {
                  month: "January",
                  link: "https://www.mediafire.com/file_premium/pfzpd9v0kv1dvxk/Alpha_01-2024.zip/file",
               },
            ],
         },
         {
            year: 2023,
            months: [
               {
                  month: "December",
                  link: "https://www.mediafire.com/file_premium/693qgex8h54zz9e/Alpha_12-2023.zip/file",
               },
               {
                  month: "November",
                  link: "https://www.mediafire.com/file_premium/uanmfecy2n17c61/Alpha_11-2023.zip/file",
               },
               {
                  month: "October",
                  link: "https://www.mediafire.com/file_premium/69k6wyivk7z5q3p/Alpha_10-2023.zip/file",
               },
               {
                  month: "September",
                  link: "https://www.mediafire.com/file_premium/ts3bygqqibuiitf/Alpha_09-2023.zip/file",
               },
               {
                  month: "August",
                  link: "https://www.mediafire.com/file_premium/rcqh887rsbf79zh/Alpha_08-2023.zip/file",
               },
               {
                  month: "July",
                  link: "https://www.mediafire.com/file_premium/qsy94csuyp6u3l2/Alpha_07-2023.zip/file",
               },
               {
                  month: "June",
                  link: "https://www.mediafire.com/file_premium/39m8fx1o26mp12d/Alpha_06-2023.zip/file",
               },
               {
                  month: "May",
                  link: "https://www.mediafire.com/file_premium/j02mokdlzo30ykd/Alpha_05-2023.zip/file",
               },
               {
                  month: "April",
                  link: "https://www.mediafire.com/file_premium/wgijcrfg3efq4k8/Alpha_04-2023.zip/file",
               },
               {
                  month: "March",
                  link: "https://www.mediafire.com/file/nqbxcl1h4jwco24/Alpha_03-2023.zip/file",
               },
               {
                  month: "February",
                  link: "https://www.mediafire.com/file/702hwavr1tql2la/Alpha_02-2023.zip/file",
               },
               {
                  month: "January",
                  link: "https://www.mediafire.com/file/baeagcj5uakgr4b/Alpha_01-2023.zip/file",
               },
            ],
         },
         {
            year: 2022,
            months: [
               {
                  month: "December",
                  link: "https://www.mediafire.com/file/qzolt15emi7vtpq/Alpha_12-2022.zip/file",
               },
               {
                  month: "November",
                  link: "https://www.mediafire.com/file/yhr8etavq3sf00k/Alpha_11-2022.zip/file",
               },
               {
                  month: "October",
                  link: "https://www.mediafire.com/file/ar1fvp0xdmeofu4/Alpha_10-2022.zip/file",
               },
               {
                  month: "September",
                  link: "https://www.mediafire.com/file/l7o28ydbnxejni6/Alpha_09-2022.zip/file",
               },
               {
                  month: "August",
                  link: "https://www.mediafire.com/file/5zy8666ki7x5wm5/Alpha_08-2022.zip/file",
               },
               {
                  month: "July",
                  link: "https://www.mediafire.com/file/ge2bcv2jn90cti7/Alpha_07-2022.zip/file",
               },
               {
                  month: "June",
                  link: "https://www.mediafire.com/file/z8175mlcvx86k8w/Alpha_06-2022.zip/file",
               },
               {
                  month: "May",
                  link: "https://www.mediafire.com/file/ixrgozc2l2av92k/Alpha_05-2022.zip/file",
               },
               {
                  month: "April",
                  link: "https://www.mediafire.com/file/k6nev62t5ceyekt/Alpha+04-2022.zip/file",
               },
               {
                  month: "March",
                  link: "https://www.mediafire.com/file/xzu4qhy2w54aueu/Alpha_03-2022.zip/file",
               },
               {
                  month: "February",
                  link: "https://www.mediafire.com/file/6ur2x4elecr5rcp/Alpha_02-2022.zip/file",
               },
               {
                  month: "January",
                  link: "https://www.mediafire.com/file/g1eer4y8262563g/Alpha_01-2022.zip/file",
               },
            ],
         },
         {
            year: 2021,
            months: [
               {
                  month: "December",
                  link: "https://www.mediafire.com/file/6291hm6bry1kxae/Alpha_12-2021.zip/file",
               },
               {
                  month: "November",
                  link: "https://www.mediafire.com/file/jaqg4pn5eijgj85/Alpha_11-2021.zip/file",
               },
               {
                  month: "October",
                  link: "https://www.mediafire.com/file/c06gw4wcp3v7thn/Alpha_10-2021.zip/file",
               },
               {
                  month: "September",
                  link: "https://www.mediafire.com/file/8n3068rq68n3xfn/Alpha_09-2021.zip/file",
               },
               {
                  month: "August",
                  link: "https://www.mediafire.com/file/6qs6k72eg09rzp2/Alpha_08-2021.zip/file",
               },
               {
                  month: "July",
                  link: "https://www.mediafire.com/file/vbg8567x0opuc14/Alpha_07-2021.zip/file",
               },
               {
                  month: "June",
                  link: "https://www.mediafire.com/file/dscwitig5wbpjtm/Alpha_06-2021.zip/file",
               },
               {
                  month: "May",
                  link: "https://www.mediafire.com/file/be3a5k4m49n2zp5/Alpha_05-2021.zip/file",
               },
               {
                  month: "April",
                  link: "https://www.mediafire.com/file/xfvuah3ffcx8m98/Alpha_04-2021.zip/file",
               },
               {
                  month: "March",
                  link: "http://www.mediafire.com/file/7e9rjudgoh0ayk2/Alpha_03-2021.zip/file",
               },
               {
                  month: "February",
                  link: "https://www.mediafire.com/file/rkf6x54eh863prk/Alpha_02-2021.zip/file",
               },
               {
                  month: "January",
                  link: "https://www.mediafire.com/file/am7bgyrxaz1i6pu/Alpha_01-2021.zip/file",
               },
            ],
         },
         {
            year: 2020,
            months: [
               {
                  month: "December",
                  link: "http://www.mediafire.com/file/a349jbszsxtay3e/Alpha_12-2020.zip/file",
               },
               {
                  month: "November",
                  link: "http://www.mediafire.com/file/3n8a1r7ccd504xm/Alpha_11-2020.zip/file",
               },
               {
                  month: "October",
                  link: "http://www.mediafire.com/file/5lufwl41nvy2ts3/Alpha_10-2020.zip/file",
               },
               {
                  month: "September",
                  link: "http://www.mediafire.com/file/dqx17ech6n1qagn/file",
               },
               {
                  month: "August",
                  link: "http://www.mediafire.com/file/onx8tsvx4v94v2j/Alpha_08-2020.zip/file",
               },
               {
                  month: "July",
                  link: "https://www.mediafire.com/file/437cbetqn07pk11/Alpha_07-2020.zip/file",
               },
               {
                  month: "June",
                  link: "http://www.mediafire.com/file/u8fe1032d8s0vgs/Alpha_06-2020.zip/file",
               },
               {
                  month: "May",
                  link: "http://www.mediafire.com/file/f2cm4sscigmgchi/Alpha_05-2020.zip/file",
               },
               {
                  month: "April",
                  link: "https://www.mediafire.com/file/9wsx7dhbm5u2bn3/Alpha_04-2020.zip/file",
               },
               {
                  month: "March",
                  link: "http://www.mediafire.com/file/ony48ts1os0ix9q/Alpha_03-2020.zip/file",
               },
               {
                  month: "February",
                  link: "http://www.mediafire.com/file/swwyrhekvhykjki/Alpha_02-2020_%25281%2529.zip/file",
               },
               {
                  month: "January",
                  link: "http://www.mediafire.com/file/ecgahgn80rwllmv/Alpha_01-2020.zip/file",
               },
            ],
         },
         {
            year: 2019,
            months: [
               {
                  month: "December",
                  link: "http://www.mediafire.com/file/z48odpr3kapf6cm/Alpha_12-2019.zip/file",
               },
               {
                  month: "November",
                  link: "http://www.mediafire.com/file/ghkutb8eyddo3q2/Alpha_11-2019.zip/file",
               },
               {
                  month: "October",
                  link: "http://www.mediafire.com/file/wj4aqpnjt12trm3/Alpha_D_10-2019.zip/file",
               },
               {
                  month: "September",
                  link: "http://www.mediafire.com/file/jfktnc01uqaprvr/Alpha_09-2019.zip/file",
               },
            ],
         },
         {
            year: 2018,
            months: [
               {
                  month: "July",
                  link: "http://www.mediafire.com/file/nu7a2gng2twe6bh/Alpha_07-2018.zip/file",
               },
               {
                  month: "June",
                  link: "http://www.mediafire.com/file/8ft5z2kk5fo3plk/Alpha_06-2018.zip/file",
               },
               {
                  month: "May",
                  link: "http://www.mediafire.com/file/na9wdm92ahme2qf/Alpha_05-2018.zip",
               },
               {
                  month: "April",
                  link: "http://www.mediafire.com/file/qk8897p29bjv99u/Alpha_04-2018.zip",
               },
               {
                  month: "March",
                  link: "http://www.mediafire.com/file/1dy7ryut015wcw1/2018_March_Alpha.zip",
               },
               {
                  month: "February",
                  link: "http://www.mediafire.com/file/60aajbj5snufd8e/Alpha_02-2018.zip",
               },
               {
                  month: "January",
                  link: "http://www.mediafire.com/file/uudou22a71dh5qu/Alpha_01-2018.zip",
               },
            ],
         },
         {
            year: 2017,
            months: [
               {
                  month: "December",
                  link: "http://www.mediafire.com/file/ez0086zacznqjus/ALPHA_DEC_2017.zip",
               },
               {
                  month: "November",
                  link: "http://www.mediafire.com/file/mq36dq01mb8d2l5/2017_November_Alpha.zip",
               },
               {
                  month: "October",
                  link: "http://www.mediafire.com/file/9ha615g55vig144/2017_October_Alpha.zip",
               },
               {
                  month: "September",
                  link: "http://www.mediafire.com/file/5a4e630mrqhu8lq/2017_September_Alpha.zip",
               },
               {
                  month: "August",
                  link: "http://www.mediafire.com/file/38hyaae7n6dkkfy/2017_August_Alpha.zip",
               },
               {
                  month: "July",
                  link: "http://www.mediafire.com/file/xw5bllm4atl05d8/2017_July_Alpha.zip",
               },
               {
                  month: "June",
                  link: "http://www.mediafire.com/file/fci4cvlnu4eydqt/2017_June_Alpha.zip",
               },
               {
                  month: "May",
                  link: "http://www.mediafire.com/file/kwada3s3s3jom1u/2017_May_Alpha.zip",
               },
               {
                  month: "April",
                  link: "http://www.mediafire.com/file/xvlnvb5yjiqp25e/2017_April_Alpha.zip",
               },
               {
                  month: "March",
                  link: "http://www.mediafire.com/file/qaedqib95trjuee/2017_March_Alpha.zip",
               },
               {
                  month: "February",
                  link: "http://www.mediafire.com/file/eu88ugj1ct16a0q/2017_February_Alpha.zip",
               },
               {
                  month: "January",
                  link: "http://www.mediafire.com/file/k9l4h2a5qot25sk/2017_January_Alpha.rar",
               },
            ],
         },
         {
            year: 2016,
            months: [
               {
                  month: "December",
                  link: "http://www.mediafire.com/file/brx02q9b9msss95/2016_December_Alpha.rar",
               },
               {
                  month: "November",
                  link: "http://www.mediafire.com/file/opq5l8xjn7hdut8/2016_November_Alpha.rar",
               },
               {
                  month: "October",
                  link: "http://www.mediafire.com/file/96umzhpyqvqc6ea/2016_October_Alpha.rar",
               },
               {
                  month: "September",
                  link: "http://www.mediafire.com/file/3bwj8qvp2nmxrgg/2016_September_Alpha.rar",
               },
               {
                  month: "August",
                  link: "http://www.mediafire.com/file/6r38dproyskdgqd/2016_August_Alpha.rar",
               },
            ],
         },
      ],
   },
   {
      product: "Cello",
      years: [
         {
            year: 2026,
            months: [
               {
                  month: "October",
                  size: "64GB",
                  link: "https://www.mediafire.com/file_premium/ad4tr1ev44458dq/Cello_D_64GB_10-2026.zip/file",
               },
               {
                  month: "October",
                  size: "32GB",
                  link: "https://www.mediafire.com/file_premium/wus2ctou42b6idk/Cello_D_10-2026.zip/file",
               },
               {
                  month: "September",
                  size: "64GB",
                  link: "https://www.mediafire.com/file_premium/niepfrpthp5mzvs/Cello_D_64GB_09-2026.zip/file",
               },
               {
                  month: "September",
                  size: "32GB",
                  link: "https://www.mediafire.com/file_premium/p1wjm5v58rccfwt/Cello_D_09-2026.zip/file",
               },
               {
                  month: "August",
                  size: "64GB",
                  link: "https://www.mediafire.com/file_premium/hf68ivtlcvak3ha/Cello_D_64GB_08-2026.zip/file",
               },
               {
                  month: "August",
                  size: "32GB",
                  link: "https://www.mediafire.com/file_premium/npqmm9zo2cq83ir/Cello_D_08-2026.zip/file",
               },
               {
                  month: "July",
                  size: "64GB",
                  link: "https://www.mediafire.com/file_premium/8h6nebnwt7u0ogx/Cello_D_64GB_07-2026.zip/file",
               },
               {
                  month: "July",
                  size: "32GB",
                  link: "https://www.mediafire.com/file_premium/8yjgj3d8ghp5kx3/Cello_D_07-2026.zip/file",
               },
               {
                  month: "June",
                  size: "64GB",
                  link: "https://www.mediafire.com/file_premium/pgitzkhcsuasbsv/Cello_D_64GB_06-2026.zip/file",
               },
               {
                  month: "June",
                  size: "32GB",
                  link: "https://www.mediafire.com/file_premium/zpmzy2gmhi3jq01/Cello_D_06-2026.zip/file",
               },
               {
                  month: "May",
                  size: "64GB",
                  link: "https://www.mediafire.com/file_premium/xppyotckota6cl9/Cello_D_64GB_05-2026.zip/file",
               },
               {
                  month: "May",
                  size: "32GB",
                  link: "https://www.mediafire.com/file_premium/4ncdqs78ietoim7/Cello_D_05-2026.zip/file",
               },
               {
                  month: "April",
                  size: "64GB",
                  link: "https://www.mediafire.com/file_premium/hohyknwxyjghx05/Cello_D_64GB_04-2026.zip/file",
               },
               {
                  month: "April",
                  size: "32GB",
                  link: "https://www.mediafire.com/file_premium/7pw2gf9sonqyuf1/Cello_D_03-2026.zip/file",
               },
               {
                  month: "March",
                  size: "64GB",
                  link: "https://www.mediafire.com/file_premium/cap5rl8aok0leon/Cello_D_64GB_03-2026.zip/file",
               },
               {
                  month: "March",
                  size: "32GB",
                  link: "https://www.mediafire.com/file_premium/7pw2gf9sonqyuf1/Cello_D_03-2026.zip/file",
               },
               {
                  month: "February",
                  size: "64GB",
                  link: "https://www.mediafire.com/file_premium/ivw5neqrlqzbhb6/Cello_D_64GB_02-2026.zip/file",
               },
               {
                  month: "February",
                  size: "32GB",
                  link: "https://www.mediafire.com/file_premium/3rw4kmhffniez8k/Cello_D_02-2026.zip/file",
               },
               {
                  month: "January",
                  size: "64GB",
                  link: "https://www.mediafire.com/file_premium/vamwemvuhqs2vyn/Cello_D_64GB_01-2026.zip/file",
               },
               {
                  month: "January",
                  size: "32GB",
                  link: "https://www.mediafire.com/file_premium/7q2n9s0ganm1kya/Cello_D_01-2026.zip/file",
               },
            ],
         },
         {
            year: 2025,
            months: [
               {
                  month: "December",
                  size: "64GB",
                  link: "https://www.mediafire.com/file_premium/zh43nbc0592dyrq/Cello_D_64GB_12-2025.zip/file",
               },
               {
                  month: "December",
                  size: "32GB",
                  link: "https://www.mediafire.com/file_premium/vq47d63cwz1ewwo/Cello_D_12-2025.zip/file",
               },
               {
                  month: "November",
                  size: "64GB",
                  link: "https://www.mediafire.com/file_premium/zvyuxq2hp4w8t17/Cello_D_64GB_11-2025.zip/file",
               },
               {
                  month: "November",
                  size: "32GB",
                  link: "https://www.mediafire.com/file_premium/68bfckhmzz8ccn4/Cello_D_11-2025.zip/file",
               },
               {
                  month: "October",
                  size: "64GB",
                  link: "https://www.mediafire.com/file_premium/z1b21bi8kvmpbd7/Cello_D_64GB_10-2025.zip/file",
               },
               {
                  month: "October",
                  size: "32GB",
                  link: "https://www.mediafire.com/file_premium/mvsebzw0f9fq7g4/Cello_D_09-2025.zip/file",
               },
               {
                  month: "September",
                  size: "64GB",
                  link: "https://www.mediafire.com/file_premium/cs754extfxsj2l8/Cello_D_64GB_09-2025.zip/file",
               },
               {
                  month: "September",
                  size: "32GB",
                  link: "https://www.mediafire.com/file_premium/mvsebzw0f9fq7g4/Cello_D_09-2025.zip/file",
               },
               {
                  month: "August",
                  size: "64GB",
                  link: "https://www.mediafire.com/file_premium/txrgiy0dqlrfo2b/Cello_D_64GB_08-2025.zip/file",
               },
               {
                  month: "August",
                  size: "32GB",
                  link: "https://www.mediafire.com/file_premium/8wyl75gceuij62w/Cello_D_08-2025.zip/file",
               },
               {
                  month: "July",
                  size: "64GB",
                  link: "https://www.mediafire.com/file_premium/wsbzm50he7jxrfv/Cello_D_64GB_07-2025.zip/file",
               },
               {
                  month: "July",
                  size: "32GB",
                  link: "https://www.mediafire.com/file_premium/v65d0yrmy82muxt/Cello_D_07-2025.zip/file",
               },
               {
                  month: "June",
                  size: "64GB",
                  link: "https://www.mediafire.com/file_premium/qxo8f8yg1zs867a/Cello_D_64GB_06-2025.zip/file",
               },
               {
                  month: "June",
                  size: "32GB",
                  link: "https://www.mediafire.com/file_premium/abif5uhfexsniu9/Cello_D_06-2025.zip/file",
               },
               {
                  month: "May",
                  size: "64GB",
                  link: "https://www.mediafire.com/file_premium/2r8m74gmz0re1xo/Cello_D_64GB_05-2025.zip/file",
               },
               {
                  month: "May",
                  size: "32GB",
                  link: "https://www.mediafire.com/file_premium/73r29qbe08h2fyk/Cello_D_05-2025.zip/file",
               },
               {
                  month: "April",
                  size: "64GB",
                  link: "https://www.mediafire.com/file_premium/v15y7e31c6d3sdv/Cello_D_64GB_04-2025.zip/file",
               },
               {
                  month: "April",
                  size: "32GB",
                  link: "https://www.mediafire.com/file_premium/g1e64szpc2jjlja/Cello_D_04-2025.zip/file",
               },
               {
                  month: "March",
                  size: "64GB",
                  link: "https://www.mediafire.com/file_premium/bnlw0aienknjfom/Cello_D_64GB_03-2025.zip/file",
               },
               {
                  month: "March",
                  size: "32GB",
                  link: "https://www.mediafire.com/file_premium/ndzsh383x0bwikg/Cello_D_03-2025.zip/file",
               },
               {
                  month: "February",
                  size: "64GB",
                  link: "https://www.mediafire.com/file_premium/i3fpqyxubfvs5ue/Cello_D_64GB_02-2025.zip/file",
               },
               {
                  month: "February",
                  size: "32GB",
                  link: "https://www.mediafire.com/file_premium/zva77d7lfr4kpx8/Cello_D_02-2025.zip/file",
               },
               {
                  month: "January",
                  size: "64GB",
                  link: "https://www.mediafire.com/file_premium/cs7ld61svr8cu20/Cello_D_64GB_01-2025.zip/file",
               },
               {
                  month: "January",
                  size: "32GB",
                  link: "https://www.mediafire.com/file_premium/7o3fevttj6mwbrk/Cello_D_01-2025.zip/file",
               },
            ],
         },
         {
            year: 2024,
            months: [
               {
                  month: "December",
                  size: "64GB",
                  link: "https://www.mediafire.com/file_premium/beu1s5wpffzj83v/Cello_D_64GB_12-2024.zip/file",
               },
               {
                  month: "December",
                  size: "32GB",
                  link: "https://www.mediafire.com/file_premium/m8asrx9ir9sjb1a/Cello_D_12-2024.zip/file",
               },
               {
                  month: "November",
                  size: "64GB",
                  link: "https://www.mediafire.com/file_premium/uqo89yknrvxpur4/Cello_D_64GB_11-2024.zip/file",
               },
               {
                  month: "November",
                  size: "32GB",
                  link: "https://www.mediafire.com/file_premium/u4a3k5cdee605d9/Cello_D_11-2024.zip/file",
               },
               {
                  month: "October",
                  size: "64GB",
                  link: "https://www.mediafire.com/file_premium/e24z16vnodr9thn/Cello_D_64GB_10-2024.zip/file",
               },
               {
                  month: "October",
                  size: "32GB",
                  link: "https://www.mediafire.com/file_premium/rs0k45zgsznmlfw/Cello_D_10-2024.zip/file",
               },
               {
                  month: "September",
                  size: "64GB",
                  link: "https://www.mediafire.com/file_premium/bqpf79jugqesqvv/Cello_D_64GB_09-2024.zip/file",
               },
               {
                  month: "September",
                  size: "32GB",
                  link: "https://www.mediafire.com/file_premium/v5o2uak3fnmzedn/Cello_D_09-2024.zip/file",
               },
               {
                  month: "August",
                  size: "64GB",
                  link: "https://www.mediafire.com/file_premium/0m8qxit610vcidg/Cello_D_64GB_08-2024.zip/file",
               },
               {
                  month: "August",
                  size: "32GB",
                  link: "https://www.mediafire.com/file_premium/0ietf07oh6s53mp/Cello_D_08-2024.zip/file",
               },
               {
                  month: "July",
                  size: "64GB",
                  link: "https://www.mediafire.com/file_premium/9utiks89z47k152/Cello_D_64GB_07-2024.zip/file",
               },
               {
                  month: "July",
                  size: "32GB",
                  link: "https://www.mediafire.com/file_premium/n58p2dwsvg16qo2/Cello_D_07-2024.zip/file",
               },
               {
                  month: "June",
                  size: "64GB",
                  link: "https://www.mediafire.com/file_premium/ljvl7x4ju3e8g87/Cello_D_64GB_06-2024.zip/file",
               },
               {
                  month: "June",
                  size: "32GB",
                  link: "https://www.mediafire.com/file_premium/9rwzvyi9odrne2g/Cello_D_06-2024.zip/file",
               },
               {
                  month: "May",
                  size: "64GB",
                  link: "https://www.mediafire.com/file_premium/6jwlov24zg86dkh/Cello_D_64GB_05-2024.zip/file",
               },
               {
                  month: "May",
                  size: "32GB",
                  link: "https://www.mediafire.com/file_premium/ves8hjfl7ejfqyl/Cello_D_05-2024.zip/file",
               },
               {
                  month: "April",
                  size: "64GB",
                  link: "https://www.mediafire.com/file_premium/ek12aae27oby3uc/Cello_D_64GB_04-2024.zip/file",
               },
               {
                  month: "April",
                  size: "32GB",
                  link: "https://www.mediafire.com/file_premium/s10x4j8vrxu955f/Cello_D_04-2024.zip/file",
               },
               {
                  month: "March",
                  size: "64GB",
                  link: "https://www.mediafire.com/file_premium/mjar9g8hzmem3x8/Cello_D_64GB_03-2024.zip/file",
               },
               {
                  month: "March",
                  size: "32GB",
                  link: "https://www.mediafire.com/file_premium/n8sm40cp0a3o6va/Cello_D_03-2024.zip/file",
               },
               {
                  month: "February",
                  size: "64GB",
                  link: "https://www.mediafire.com/file_premium/628vuzyobq3jhv1/Cello_D_64GB_02-2024.zip/file",
               },
               {
                  month: "February",
                  size: "32GB",
                  link: "https://www.mediafire.com/file_premium/deuv0ofarpjvy54/Cello_D_02-2024.zip/file",
               },
               {
                  month: "January",
                  size: "64GB",
                  link: "https://www.mediafire.com/file_premium/wbsifyz2fsqltyg/Cello_D_64GB_01-2024.zip/file",
               },
               {
                  month: "January",
                  size: "32GB",
                  link: "https://www.mediafire.com/file_premium/c549xeud5irqblp/Cello_D_01-2024.zip/file",
               },
            ],
         },
         {
            year: 2023,
            months: [
               {
                  month: "December",
                  size: "64GB",
                  link: "https://www.mediafire.com/file_premium/kxjkayj17l3bjd6/Cello_D_64GB_12-2023.zip/file",
               },
               {
                  month: "December",
                  size: "32GB",
                  link: "https://www.mediafire.com/file_premium/f7xmc8sipe2a476/Cello_D_12-2023.zip/file",
               },
               {
                  month: "November",
                  size: "64GB",
                  link: "https://www.mediafire.com/file_premium/1n4ojwqfmk72je7/Cello_D_64GB_11-2023.zip/file",
               },
               {
                  month: "November",
                  size: "32GB",
                  link: "https://www.mediafire.com/file_premium/frqnk4lzh7xk6er/Cello_D_11-2023.zip/file",
               },
               {
                  month: "October",
                  size: "64GB",
                  link: "https://www.mediafire.com/file_premium/7qg0s4byu8lb08v/Cello_D_64GB_10-2023.zip/file",
               },
               {
                  month: "October",
                  size: "32GB",
                  link: "https://www.mediafire.com/file_premium/ji20eheheet63kp/Cello_D_10-2023.zip/file",
               },
               {
                  month: "September",
                  size: "64GB",
                  link: "https://www.mediafire.com/file_premium/cn64sk406du20m3/Cello_D_64GB_09-2023.zip/file",
               },
               {
                  month: "September",
                  size: "32GB",
                  link: "https://www.mediafire.com/file_premium/j7c39n2gbrgfehr/Cello_D_09-2023.zip/file",
               },
               {
                  month: "August",
                  size: "64GB",
                  link: "https://www.mediafire.com/file_premium/2i972toobm069z7/Cello_D_64GB_08-2023.zip/file",
               },
               {
                  month: "August",
                  size: "32GB",
                  link: "https://www.mediafire.com/file_premium/2vo0rwyaehnc3ku/Cello_D_07-2023.zip/file",
               },
               {
                  month: "July",
                  size: "64GB",
                  link: "https://www.mediafire.com/file_premium/knf79xxrc1cbp0s/Cello_D_64GB_07-2023.zip/file",
               },
               {
                  month: "July",
                  size: "32GB",
                  link: "https://www.mediafire.com/file_premium/6btjrjpj1hminxk/Cello_D_07-2023.zip/file",
               },
               {
                  month: "June",
                  size: "64GB",
                  link: "https://www.mediafire.com/file_premium/tl7pnuaufn3h4rk/Cello_D_64GB_06-2023.zip/file",
               },
               {
                  month: "June",
                  size: "32GB",
                  link: "https://www.mediafire.com/file_premium/c8r1pkudps898xt/Cello_D_06-2023.zip/file",
               },
               {
                  month: "May",
                  size: "64GB",
                  link: "https://www.mediafire.com/file_premium/bpcx1xks6ivgvlq/Cello_D_64GB_05-2023.zip/file",
               },
               {
                  month: "May",
                  size: "32GB",
                  link: "https://www.mediafire.com/file_premium/y5axhkfkmtzao1b/Cello_D_05-2023.zip/file",
               },
               {
                  month: "April",
                  size: "64GB",
                  link: "https://www.mediafire.com/file_premium/o38r164wq1o0gsm/Cello_D_64GB_04-2023.zip/file",
               },
               {
                  month: "April",
                  size: "32GB",
                  link: "https://www.mediafire.com/file_premium/jztt9drqku578lu/Cello_D_04-2023.zip/file",
               },
               {
                  month: "March",
                  size: "64GB",
                  link: "https://www.mediafire.com/file/r82haplbej0p1rc/Cello_D_64GB_03-2023.zip/file",
               },
               {
                  month: "March",
                  size: "32GB",
                  link: "https://www.mediafire.com/file/ofn1jgfk7q1dc2z/Cello_D_03-2023.zip/file",
               },
               {
                  month: "February",
                  size: "64GB",
                  link: "https://www.mediafire.com/file/ma7zi4urbkie6ru/Cello_D_64GB_02-2023.zip/file",
               },
               {
                  month: "February",
                  size: "32GB",
                  link: "https://www.mediafire.com/file/dnhnnix072s7i3l/Cello_D_02-2023.zip/file",
               },
               {
                  month: "January",
                  size: "64GB",
                  link: "https://www.mediafire.com/file/j3uizdyqhuii96q/Cello_D_64GB_01-2023.zip/file",
               },
               {
                  month: "January",
                  size: "32GB",
                  link: "https://www.mediafire.com/file/tgf9oxvni0rskcu/Cello_D_01-2023.zip/file",
               },
            ],
         },
         {
            year: 2022,
            months: [
               {
                  month: "December",
                  size: "64GB",
                  link: "https://www.mediafire.com/file/jm1srpfk0c00zyk/Cello_D_64GB_12-2022.zip/file",
               },
               {
                  month: "December",
                  size: "32GB",
                  link: "https://www.mediafire.com/file/475y0g7bb3r54ex/Cello_D_12-2022.zip/file",
               },
               {
                  month: "November",
                  size: "64GB",
                  link: "https://www.mediafire.com/file/qml206on09s0jci/Cello_D_64GB_11-2022.zip/file",
               },
               {
                  month: "November",
                  size: "32GB",
                  link: "https://www.mediafire.com/file/efh9osg5m7fiw0z/Cello_D_11-2022.zip/file",
               },
               {
                  month: "October",
                  size: "64GB",
                  link: "https://www.mediafire.com/file/e57yzchnzlwx44e/Cello_D_64GB_10-2022.zip/file",
               },
               {
                  month: "October",
                  size: "32GB",
                  link: "https://www.mediafire.com/file/cmvixz0nk3tcbfx/Cello_D_10-2022.zip/file",
               },
               {
                  month: "September",
                  size: "64GB",
                  link: "https://www.mediafire.com/file/0kn9y5fl2pa6ddh/Cello_D_64GB_09-2022.zip/file",
               },
               {
                  month: "September",
                  size: "32GB",
                  link: "https://www.mediafire.com/file/o51uzs7cthqxaw0/Cello_D_09-2022.zip/file",
               },
               {
                  month: "August",
                  size: "64GB",
                  link: "https://www.mediafire.com/file/t7880svpqio18rc/Cello_D_64GB_08-2022.zip/file",
               },
               {
                  month: "August",
                  size: "32GB",
                  link: "https://www.mediafire.com/file/12uezn5zwvtbw4m/Cello_D_08-2022.zip/file",
               },
               {
                  month: "July",
                  size: "64GB",
                  link: "https://www.mediafire.com/file/2omlb9tri6wim9s/Cello_D_64GB_06-2022.zip/file",
               },
               {
                  month: "July",
                  size: "32GB",
                  link: "https://www.mediafire.com/file/59a888xopaa9ia6/Cello_D_07-2022.zip/file",
               },
               {
                  month: "June",
                  size: "64GB",
                  link: "https://www.mediafire.com/file/un31pao9z9aekbw/Cello_D_64GB_06-2022.zip/file",
               },
               {
                  month: "June",
                  size: "32GB",
                  link: "https://www.mediafire.com/file/ywbzhsco1jeue8v/Cello_D_06-2022.zip/file",
               },
               {
                  month: "May",
                  size: "64GB",
                  link: "https://www.mediafire.com/file/3nz7xwh4m0unp2c/Cello_D_64GB_05-2022.zip/file",
               },
               {
                  month: "May",
                  size: "32GB",
                  link: "https://www.mediafire.com/file/fsdfkxb70yp8xlr/Cello_D_05-2022.zip/file",
               },
               {
                  month: "April",
                  size: "64GB",
                  link: "https://www.mediafire.com/file/4h8ze6lyycanvla/Cello_D_64GB+04-2022.zip/file",
               },
               {
                  month: "April",
                  size: "32GB",
                  link: "https://www.mediafire.com/file/mb3ansushx28vcd/Cello_D_04-2022.zip/file",
               },
               {
                  month: "March",
                  size: "64GB",
                  link: "https://www.mediafire.com/file/e878kuhj110ibbz/Cello_D_64GB_03-2022.zip/file",
               },
               {
                  month: "March",
                  size: "32GB",
                  link: "https://www.mediafire.com/file/8it28hayp0fmaki/Cello_D_03-2022.zip/file",
               },
               {
                  month: "February",
                  size: "64GB",
                  link: "https://www.mediafire.com/file/9nt62luf9jppol2/Cello_D_64GB_02-2022.zip/file",
               },
               {
                  month: "February",
                  size: "32GB",
                  link: "https://www.mediafire.com/file/bcnasui7gb6yj4p/Cello_D_02-2022.zip/file",
               },
               {
                  month: "January",
                  size: "64GB",
                  link: "https://www.mediafire.com/file/kqccawxbgfc1dzb/Cello_D_64GB_01-2022.zip/file",
               },
               {
                  month: "January",
                  size: "32GB",
                  link: "https://www.mediafire.com/file/mijjqf4loec5kkv/Cello_D_01-2022.zip/file",
               },
            ],
         },
         {
            year: 2021,
            months: [
               {
                  month: "December",
                  size: "64GB",
                  link: "https://www.mediafire.com/file/muab5wi9ry1si2p/Cello_D_64GB_12-2021.zip/file",
               },
               {
                  month: "December",
                  size: "32GB",
                  link: "https://www.mediafire.com/file/2p665hmg4mf0ekh/Cello_D_12-2021.zip/file",
               },
               {
                  month: "November",
                  size: "64GB",
                  link: "https://www.mediafire.com/file/ljgbelv8ayo9yyp/Cello_D_64GB+11-2021.zip/file",
               },
               {
                  month: "November",
                  size: "32GB",
                  link: "https://www.mediafire.com/file/d8y7lougq21t178/Cello_D+11-2021.zip/file",
               },
               {
                  month: "October",
                  size: "64GB",
                  link: "https://www.mediafire.com/file/rktxuc6qtgtend3/Cello_D_64GB_10-2021.zip/file",
               },
               {
                  month: "October",
                  size: "32GB",
                  link: "https://www.mediafire.com/file/u1bhyg0zr6o9suc/Cello_D_10-2021.zip/file",
               },
               {
                  month: "September",
                  size: "64GB",
                  link: "https://www.mediafire.com/file/exv64209kmpjoyf/Cello_D_64GB_09-2021.zip/file",
               },
               {
                  month: "September",
                  size: "32GB",
                  link: "https://www.mediafire.com/file/x8i5mu5585yjced/Cello_D_09-2021.zip/file",
               },
               {
                  month: "August",
                  size: "64GB",
                  link: "https://www.mediafire.com/file/lz6ja4xmofsr2go/Cello_D_64GB+08-2021.zip/file",
               },
               {
                  month: "August",
                  size: "32GB",
                  link: "https://www.mediafire.com/file/zzu4hq0uk6ef82o/Cello_D+08-2021.zip/file",
               },
               {
                  month: "July",
                  size: "64GB",
                  link: "https://www.mediafire.com/file/2nz9lf9cvrt7vly/Cello_D_64GB+07-2021.zip/file",
               },
               {
                  month: "July",
                  size: "32GB",
                  link: "https://www.mediafire.com/file/hcgvh8y5cajf7fn/Cello_D+07-2021.zip/file",
               },
               {
                  month: "June",
                  size: "64GB",
                  link: "https://www.mediafire.com/file/660w1kq5ua0ym8f/Cello_D_64GB+06-2021.zip/file",
               },
               {
                  month: "June",
                  size: "32GB",
                  link: "https://www.mediafire.com/file/r3lja55js64x5i7/Cello_D_06-2021.zip/file",
               },
               {
                  month: "May",
                  size: "64GB",
                  link: "https://www.mediafire.com/file/gafuljkvw2sxkvz/Cello_D_64GB_05-2021.zip/file",
               },
               {
                  month: "May",
                  size: "32GB",
                  link: "https://www.mediafire.com/file/kfyb65i7rt1o50q/Cello_D_05-2021.zip/file",
               },
               {
                  month: "April",
                  size: "64GB",
                  link: "https://www.mediafire.com/file/q4p208oadbhag5z/Cello_D_64GB_04-2021.zip/file",
               },
               {
                  month: "April",
                  size: "32GB",
                  link: "https://www.mediafire.com/file/z9lhp6bfbo4coc1/Cello_D_04-2021.zip/file",
               },
               {
                  month: "March",
                  size: "64GB",
                  link: "http://www.mediafire.com/file/vwcwc8yxtgxpc5n/Cello_D_64GB_03-2021.zip/file",
               },
               {
                  month: "March",
                  size: "32GB",
                  link: "http://www.mediafire.com/file/27ludknhnf4924m/Cello_D_03-2021.zip/file",
               },
               {
                  month: "February",
                  size: "64GB",
                  link: "https://www.mediafire.com/file/dnq2gi6lulrduk3/Cello_D_64GB_02-2021.zip/file",
               },
               {
                  month: "February",
                  size: "32GB",
                  link: "https://www.mediafire.com/file/09quy5jlt7zt7lb/Cello_D_02-2021.zip/file",
               },
               {
                  month: "January",
                  size: "64GB",
                  link: "https://www.mediafire.com/file/r9cifywfkjdhhon/Cello_D_64GB_01-2021.zip/file",
               },
               {
                  month: "January",
                  size: "32GB",
                  link: "https://www.mediafire.com/file/wc4ctdc72ecj5gl/Cello_D_01-2021.zip/file",
               },
            ],
         },
         {
            year: 2020,
            months: [
               {
                  month: "December",
                  size: "64GB",
                  link: "http://www.mediafire.com/file/emnvav6pq54cmgy/Cello_D_64GB_12-2020.zip/file",
               },
               {
                  month: "December",
                  size: "32GB",
                  link: "http://www.mediafire.com/file/fmt01a2neip3fvb/Cello_D_12-2020.zip/file",
               },
               {
                  month: "November",
                  size: "32GB",
                  link: "http://www.mediafire.com/file/4qlgsxi2lfy32qi/Cello_D_11-2020.zip/file",
               },
               {
                  month: "October",
                  size: "32GB",
                  link: "http://www.mediafire.com/file/qn6l3y4ibxiatys/Cello_D_10-2020.zip/file",
               },
               {
                  month: "September",
                  size: "32GB",
                  link: "http://www.mediafire.com/file/jbecpplex7odlpz/file",
               },
               {
                  month: "August",
                  size: "32GB",
                  link: "https://www.mediafire.com/file/zex7a4qzn3dlost/Cello_D_08-2020.zip/file",
               },
               {
                  month: "July",
                  size: "32GB",
                  link: "https://www.mediafire.com/file/apa37s6a7ae0dv2/Cello_D_07-2020.zip/file",
               },
               {
                  month: "June",
                  size: "32GB",
                  link: "http://www.mediafire.com/file/4ebx5x12oyx4xfu/Cello_D_06-2020.zip/file",
               },
               {
                  month: "May",
                  size: "32GB",
                  link: "http://www.mediafire.com/file/yyv1dc8xwzlcbc0/Cello_D_05-2020.zip/file",
               },
               {
                  month: "April",
                  size: "32GB",
                  link: "https://www.mediafire.com/file/7pe4k2fe0cfzxfp/Cello_D_04-2020.zip/file",
               },
               {
                  month: "March",
                  size: "32GB",
                  link: "http://www.mediafire.com/file/fywf8idc31u9gif/Cello_D_03-2020.zip/file",
               },
               {
                  month: "February",
                  size: "32GB",
                  link: "http://www.mediafire.com/file/jqx3tz774o9tdo9/Cello_D_02-2020.zip/file",
               },
               {
                  month: "January",
                  size: "32GB",
                  link: "http://www.mediafire.com/file/tshvkfl7udgx3tk/Cello_D_01-2020.zip/file",
               },
            ],
         },
         {
            year: 2019,
            months: [
               {
                  month: "December",
                  size: "32GB",
                  link: "http://www.mediafire.com/file/3tp0loiit1ind47/Cello_D_12-2019.zip/file",
               },
               {
                  month: "November",
                  size: "32GB",
                  link: "http://www.mediafire.com/file/vkjdsvcnqbx7i6r/Cello_D_11-2019.zip/file",
               },
               {
                  month: "October",
                  size: "32GB",
                  link: "http://www.mediafire.com/file/vkjdsvcnqbx7i6r/Cello_D_11-2019.zip/file",
               },
               {
                  month: "September",
                  size: "32GB",
                  link: "http://www.mediafire.com/file/jc2o4fgf57f6uht/Cello_D_09-2019.zip/file",
               },
               {
                  month: "August",
                  size: "32GB",
                  link: "http://www.mediafire.com/file/hkwtj0zrwlg6s4z/Cello_D_08-2019.zip/file",
               },
               {
                  month: "July",
                  size: "32GB",
                  link: "http://www.mediafire.com/file/fdlramdv18406to/Cello_D_07-2019.zip/file",
               },
               {
                  month: "June",
                  size: "32GB",
                  link: "http://www.mediafire.com/file/5pu9l7nipz54fh5/Cello_D_06-2019.zip/file",
               },
               {
                  month: "May",
                  size: "32GB",
                  link: "http://www.mediafire.com/file/yt20m9h17cte49e/Cello_D_05-2019.zip/file",
               },
               {
                  month: "April",
                  size: "32GB",
                  link: "http://www.mediafire.com/file/7mgmetoyozyk997/Cello_D_04-2019.zip/file",
               },
            ],
         },
      ],
   },
   {
      product: "Major HD-10",
      years: [
         {
            year: 2021,
            months: [
               {
                  month: "November",
                  link: "https://www.mediafire.com/file/k5zc3cd8pq3m8eh/Major_11-2021.zip/file",
               },
               {
                  month: "October",
                  link: "https://www.mediafire.com/file/1tgxc7inc7r2j2d/Major_10-2021.zip/file",
               },
               {
                  month: "September",
                  link: "https://www.mediafire.com/file/59gotrv03a9xeln/Major_09-2021.zip/file",
               },
               {
                  month: "August",
                  link: "https://www.mediafire.com/file/3lc88cu8339ew56/Major_08-2021.zip/file",
               },
               {
                  month: "August (Indian Songs)",
                  link: "https://www.mediafire.com/file/03gvgclhusjo6jc/HD-10_Indian_Song_Update_08-2021.zip/file",
               },
               {
                  month: "July",
                  link: "https://www.mediafire.com/file/initcw06srkkw6o/Major+07-2021.zip/file",
               },
               {
                  month: "June",
                  link: "https://www.mediafire.com/file/w8060b7e3pgd80k/Major_06-2021.zip/file",
               },
               {
                  month: "May",
                  link: "https://www.mediafire.com/file/457hwsevjd7xuw5/Major_05-2021.zip/file",
               },
               {
                  month: "April",
                  link: "https://www.mediafire.com/file/5add5b13hsko330/Major_04-2021.zip/file",
               },
               {
                  month: "March",
                  link: "http://www.mediafire.com/file/ldim6ujoq5ejaz8/Major_03-2021.zip/file",
               },
               {
                  month: "February",
                  link: "https://www.mediafire.com/file/lzb08r09rqek899/Major_02-2021.zip/file",
               },
               {
                  month: "January",
                  link: "https://www.mediafire.com/file/v86nxcdf7ei77rv/Major_01-2021.zip/file",
               },
            ],
         },
         {
            year: 2020,
            months: [
               {
                  month: "December",
                  link: "http://www.mediafire.com/file/a304l4n2s6d830j/Major_12-2020.zip/file",
               },
               {
                  month: "November",
                  link: "http://www.mediafire.com/file/iyqzc3n2z69sy2s/Major_11-2020.zip/file",
               },
               {
                  month: "October",
                  link: "http://www.mediafire.com/file/mk6o75vtyrycxg6/file",
               },
               {
                  month: "September",
                  link: "http://www.mediafire.com/file/n38ilfguub3sylj/file",
               },
               {
                  month: "August",
                  link: "https://www.mediafire.com/file/tlwzkos1mpe007z/Major_08-2020.zip/file",
               },
               {
                  month: "July",
                  link: "http://www.mediafire.com/file/gwjaqmb3i49nq74/Major_07-2020.zip/file",
               },
               {
                  month: "June",
                  link: "http://www.mediafire.com/file/ya0d13iwf9eudj3/Major_06-2020.zip/file",
               },
               {
                  month: "May",
                  link: "http://www.mediafire.com/file/8gdc2li3j5w2zjj/Major_05-2020.zip/file",
               },
               {
                  month: "April",
                  link: "http://www.mediafire.com/file/fot00n8a7g2m1iq/Major_04-2020.zip/file",
               },
               {
                  month: "March",
                  link: "http://www.mediafire.com/file/4c05ew6lzo5vj2r/Major_03-2020.zip/file",
               },
               {
                  month: "February",
                  link: "http://www.mediafire.com/file/wqhr3ttyutv2s8d/Major_02-2020.zip/file",
               },
               {
                  month: "January",
                  link: "http://www.mediafire.com/file/dwp2x1idvghrd3n/Major_01-2020.zip/file",
               },
            ],
         },
      ],
   },
];

const songUpdateHtml = `


   ${songUpdate
      .map(
         ({ product, years }) => `
      <details class="products">
         <summary class="product">${product}</summary>

         ${years
            .map(
               ({ year, months }) => `
            <details class="years">
               <summary class="year">${year}</summary>

               ${months
                  .map(
                     ({ month, size, link }) => `
                  <div class="month">
                     <p>${month} ${size || ""}</p>
                     <a href="${link}" target="_blank">
                        <img src="https://cdn.shopify.com/s/files/1/2581/7224/files/gempages_475038571602903838-28e7b256-cd44-4ab9-8401-1dd8dad653b0.png?v=1741678173" width="33" height="28"/>
                     </a>
                  </div>
               `,
                  )
                  .join("")}

            </details>
         `,
            )
            .join("")}

      </details>
   `,
      )
      .join("")}
`;

function initSongUpdate() {

    const root = document.getElementById("song-update-root")

    if (!root) return;

    root.innerHTML = songUpdateHtml;

    const products = document.querySelectorAll(".products");
    products.forEach(product => {
    product.addEventListener("toggle", () => {
        if (product.hasAttribute("open")) {
            products.forEach(p => {
                if (p !== product) {
                p.removeAttribute("open");
                }
            });
        }
    });
    });

    const years = document.querySelectorAll(".years");
    years.forEach(year => {
    year.addEventListener("toggle", () => {
        if (year.open) {
            years.forEach(y => {
                if (y !== year) {
                y.removeAttribute("open");
                }
            });
        }
    });
    });
}


document.addEventListener("DOMContentLoaded", initSongUpdate)
document.addEventListener("shopify:section:load", initSongUpdate)